import { Pipe, PipeTransform } from "@angular/core";

import { MedLocalizationService } from "../services/med-localization.service";
import { LOCALIZATION_TEMPLATE_VALUE } from "../constants/localization.keys";
import { STRING } from "../constants/string";

@Pipe({
  name: "translateWithValue",
  pure: false,
})
export class TranslateWithValuePipe implements PipeTransform {
  constructor(private readonly localization: MedLocalizationService) { }

  transform(value: string, insert: any = STRING.EMPTY): string {
    return this.localization.translate<string>(value).replace(LOCALIZATION_TEMPLATE_VALUE, `${insert}`);
  }
}
